export default {
  title: 'Post value estimation',
  description: 'A computed value based on your engagement rate and community size over the past three months.',
  no_price: "We don't have enough data to estimate values of your posts on this network.",
};
